import moment from "moment";
const defaultRender = (value) => (value ? value : '--');
const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        render: defaultRender,
        sorter: true,
        // sorter: (a, b) => {
        //     const nameA = `${a?.firstName ?? ''} ${a?.lastName ?? ''}`.trim();
        //     const nameB = `${b?.firstName ?? ''} ${b?.lastName ?? ''}`.trim();
        //     return nameA.localeCompare(nameB);
        // },
    },
    {
        title: 'Phone No.',
        dataIndex: 'phoneNo',
        sorter: true,
    },
    {
        title: 'From',
        dataIndex: 'paymentFrom',
        sorter: true,
        // sorter: (a, b) => a.paymentFrom - b.paymentFrom,
    },
    {
        title: 'To',
        dataIndex: 'paymentTo',
        sorter: true,
        // sorter: (a, b) => a.paymentTo - b.paymentTo,
    },
    {
        title: 'Amount',
        dataIndex: 'amount',
        sorter: true,
        // sorter: (a, b) => a.amount - b.amount,
    },
    {
        title: 'Transaction Date',
        dataIndex: 'transactionDate',
        render: defaultRender,
        sorter: true,
    },
    {
        title: 'Action By',
        dataIndex: 'actionBy',
        sorter: true,
    },
    {
        title: 'Action Date',
        dataIndex: 'actionDate',
        render: defaultRender,
        sorter: true,
    },
    {
        title: 'Status',
        dataIndex: 'status',
        sorter: true,
    },
    {
        title: 'Actions',
        dataIndex: 'actions',
    }

];

export default columns;